module.exports = __webpack_public_path__ + "img/WLG_2024_45s.8384a7a7.jpg";